import React from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'

const circularProgressSize = 24

const useStyles = makeStyles({
  progress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -circularProgressSize / 2,
    marginLeft: -circularProgressSize / 2,
  },
  statusMessage: {
    display: 'inline-flex',
    verticalAlign: 'sub',
  },
})
function StandardFormButtonSet({ handleReset, dirty, isSubmitting, status }) {
  const classes = useStyles()

  return (
    <>
      <Button
        style={{ margin: '1em 1em 0 0' }}
        variant="contained"
        onClick={handleReset}
        disabled={!dirty || isSubmitting}
      >
        Reset
      </Button>

      <Button
        type="submit"
        variant="contained"
        color="secondary"
        style={{ margin: '1em 1em 0' }}
        disabled={isSubmitting}
      >
        Submit
        {isSubmitting && (
          <CircularProgress
            size={circularProgressSize}
            className={classes.progress}
            color="secondary"
          />
        )}
      </Button>

      {status && (
        <Typography
          variant="caption"
          color={status.error && 'error'}
          className={classes.statusMessage}
        >
          {status.message}
        </Typography>
      )}
    </>
  )
}

export default StandardFormButtonSet
